/** The settings overview: every admin page, grouped, each with a line about what it is for. */

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ADMIN_NAV } from "../navigation/admin-nav";
import { adminLabel } from "../components/AdminShell";
import TenantSetupHealth from "../components/admin/TenantSetupHealth";
import OpsHealth from "../components/admin/OpsHealth";
import { useAuthStore } from "../stores/auth-store";

export default function SettingsPage() {
  const { t } = useTranslation();
  const isAdmin = useAuthStore(state => state.user?.role === "admin");
  const pages = ADMIN_NAV.map((group) => (
    <section key={group.key} aria-labelledby={`group-${group.key}`} className="space-y-3">
      <h2 id={`group-${group.key}`} className="text-lg font-semibold">{t(`nav.admin.groups.${group.key}`)}</h2>
      <ul className="grid gap-3 sm:grid-cols-2">
        {group.items.map(item => <li key={item.key}>
          <Link to={item.path} className="card block h-full hover:border-sea-300">
            <span className="flex items-center justify-between gap-2 font-medium text-gray-900">{adminLabel(t, item)}</span>
            <span className="mt-1 block text-sm text-gray-600">{t(`nav.admin.desc.${item.key}`)}</span>
          </Link>
        </li>)}
      </ul>
    </section>
  ));
  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">{t("nav.admin.title")}</h1>
      {isAdmin && <TenantSetupHealth />}
      {isAdmin && <OpsHealth />}
      {isAdmin ? <details className="border-t border-gray-200 pt-5">
        <summary className="cursor-pointer py-2 text-lg font-semibold text-gray-900">{t("ap.health.allSettings")}</summary>
        <div className="mt-5 space-y-8">{pages}</div>
      </details> : pages}
    </div>
  );
}
